import { render } from "./TradeOrderContainer.vue?vue&type=template&id=7677e8e6"
import script from "./TradeOrderContainer.vue?vue&type=script&lang=js"
export * from "./TradeOrderContainer.vue?vue&type=script&lang=js"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__